<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :actionButtons="['show']"
    :form="form"
    :title="$t('model.virtualWarehouse')"
    resource="virtual_warehouses"
    :batch-actions="batchActions"
    ref="sourcePage"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/virtual_warehouses.js';
import { abilityService } from 'beans-admin-plugin';

@Component
export default class VirtualWarehouses extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'name_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'name',
      'jushuitan_id',
      'disabled',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'name',
      'jushuitan_id',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'virtual_warehouses.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'virtual_warehouses.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  batchActions() {
    const syncJushuitanDataClick = async () => {
      await this.$request.post('/virtual_warehouses/sync_jushuitan_data', { ...this.$route.query });

      this.$message.success('同步成功');
      this.$refs.sourcePage.fetchData()
    }

    return [
      abilityService.can('virtual_warehouses.create') && (() => <el-button type='primary' onClick={() => syncJushuitanDataClick()}>同步聚水潭数据</el-button>)
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/virtual_warehouses',
    name: 'virtual_warehouses.index',
    component: VirtualWarehouses,
    props: {
      type: 'index',
    }
  },
  {
    path: '/virtual_warehouses/new',
    name: 'virtual_warehouses.new',
    component: VirtualWarehouses,
    props: {
      type: 'new',
    }
  },
  {
    path: '/virtual_warehouses/:id',
    name: 'virtual_warehouses.show',
    component: VirtualWarehouses,
    props: {
      type: 'show',
    }
  },
  {
    path: '/virtual_warehouses/:id/edit',
    name: 'virtual_warehouses.edit',
    component: VirtualWarehouses,
    props: {
      type: 'edit'
    }
  }
]
</script>
